module.exports = __webpack_public_path__ + "static/image1-f89185d0f8dd631afc727004800b036f.jpg";